import { Theme } from './types';
import { getBrandRootVariables } from './utils';

export const themes: Record<Partial<Window['APP']>, Theme> = {
  frontendBoard: {
    variables: {
      ...getBrandRootVariables('#0D9488'),
    },
    config: {
      loader: { type: 'dots' },
    },
  },

  vymoWeb: {
    config: {
      loader: { type: 'circle', color: 'var(--brand-primary)' },
    },
  },

  selfserve: {
    variables: undefined,
    config: {
      loader: undefined,
    },
  },
  uiBuilder: {
    variables: undefined,
    config: {
      loader: undefined,
    },
  },
  copilot: {
    variables: undefined,
    config: {
      loader: undefined,
    },
  },
  recruitment: {
    variables: undefined,
    config: {
      loader: undefined,
    },
  },
  onboarding: {
    variables: undefined,
    config: {
      loader: undefined,
    },
  },
  mockHostApp: {
    variables: undefined,
    config: {
      loader: undefined,
    },
  },
  external: {
    variables: undefined,
    config: {
      loader: undefined,
    },
  },
};
